import { useMemo } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const StoreBreadcrumbs = () => {
  const { t } = useTranslation(['store'])
  const params = useParams()
  const location = useLocation()

  // Helper function to format category names
  const getFormattedCategoryName = (name) => name.split('-').join(' ')

  // Function to render category breadcrumbs
  const renderStoreCategory = (name, linked = false) => {
    const niceName = getFormattedCategoryName(name)
    return linked ? (
      <Link to={`/dashboard/store/category/${name}`}>{niceName}</Link>
    ) : (
      <span>{niceName}</span>
    )
  }

  // Compute breadcrumbs based on the current route
  const breadcrumbs = useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean) // Extracts path segments
    const lastSegment = pathSegments[pathSegments.length - 1]

    switch (lastSegment) {
      case 'storeCategory':
        return params.name !== 'gift' ? <span> / {renderStoreCategory(params.name)}</span> : ''
      case 'storeProduct':
        return params.name !== 'gift' ? (
          <span>
            {' '}
            / {renderStoreCategory(params.name, true)} / {params.product}
          </span>
        ) : (
          <span> / {params.product}</span>
        )
      default:
        return ''
    }
  }, [params, location.pathname])

  return (
    <div className="ctp-store-breadcrumbs">
      <span>
        <Link to="/dashboard/store">{t('store:breadcrumbs.store')}</Link>
      </span>
      {breadcrumbs}
    </div>
  )
}

export default StoreBreadcrumbs
